import { ReactNode, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

import useIsMounted from 'lib/hooks/useIsMounted';

const Container = styled.div<{
  playAnimation?: boolean;
  stallAnimation?: boolean;
}>`
  max-width: 100%;
  height: 100%;
  ${({ playAnimation }) =>
    !playAnimation &&
    css`
      [role='img'] * {
        animation-play-state: paused;
        animation-direction: reverse;
        animation-fill-mode: backwards;
        animation-delay: unset;
      }
    `}

  ${({ stallAnimation }) =>
    stallAnimation &&
    css`
      [role='img'] * {
        animation-name: none;
      }
    `}
`;

const StalledAnimationContainer = (props: { playAnimation: boolean; children: ReactNode }) => {
  const [stallAnimation, setStallAnimation] = useState(false);
  const isMounted = useIsMounted();

  // we toggle this on the next available frame to 'reset' animations
  useEffect(() => {
    let frameRequest: number;
    setStallAnimation(true);
    if (isMounted()) {
      frameRequest = requestAnimationFrame(() => {
        setStallAnimation(false);
      });
    }
    return () => {
      cancelAnimationFrame(frameRequest);
    };
  }, [props.playAnimation, isMounted]);

  return (
    <Container playAnimation={props.playAnimation} stallAnimation={stallAnimation}>
      {props.children}
    </Container>
  );
};

export default StalledAnimationContainer;
